(function () {
  const imageNames = [
    'properties[Colletto]',
    'properties[Collar]',
    'properties[Collo  collar]',
    'properties[Collo  collar]',
    'properties[Collo collar]',
    'properties[Polsini]',
    'properties[Cuffs]',
    'properties[Davanti]',
    'properties[Front]',
    'properties[Dietro]',
    'properties[Back]',
    'properties[Cucitura bottoni]',
    'properties[Seam]',
    'properties[Taschino]',
    'properties[Pocket]',
    'properties[Bottoni]',
    'properties[Buttons]' // incluso
  ];
  const checkboxFrames = [2, 6, 8, 27];
  const deadline = Date.now() + 4000; // più tempo per caricamento

  const visible = el => !!(el && el.offsetParent);
  const getVal = el =>
    el?.getAttribute('data-value') ??
    el?.getAttribute('data-val') ??
    el?.value ??
    (el?.textContent || '').trim();

  function setFirstImage(name) {
    const ready = typeof window.chooseimage === 'function';
    if (!ready) return false;

    const any = document.querySelector(`.pplr-swatch-element[name="${name}"]`);
    if (!any) return false;

    const container =
      any.closest('.pplr-swatch-main') ||
      any.closest('.pplrgcolor') ||
      any.parentElement;

    const list = Array.from(
      container.querySelectorAll(`.pplr-swatch-element[name="${name}"]`)
    ).filter(visible);
    if (!list.length) return false;

    // se già selezionato, esci
    const already = list.some(el => el.classList.contains('selected'));
    if (already) return true;

    // --- logica personalizzata per BOTTONI ---
    if (name === 'properties[Bottoni]') {
      const desiredVal = 'TROCAS 4 Bianco';
      const match = list.find(el => 
        (el.dataset.val || '').trim().toLowerCase() === desiredVal.toLowerCase()
      );
      if (match) {
        window.chooseimage(match, 0);
        return true;
      }
    }
    if (name === 'properties[Buttons]') {
      const desiredVal = 'TROCAS 4 White';
      const match = list.find(el => 
        (el.dataset.val || '').trim().toLowerCase() === desiredVal.toLowerCase()
      );
      if (match) {
        window.chooseimage(match, 0);
        return true;
      }
    }
    // ------------------------------------------

    // default: seleziona il primo
    window.chooseimage(list[0], 0);
    return true;
  }

  function setFirstCheckbox(frame) {
    const boxes = Array.from(
      document.querySelectorAll(`.pplr-checkbox-item[data-frame="${frame}"]`)
    ).filter(b => !b.disabled && visible(b));
    if (!boxes.length) return false;

    const hidden = document.querySelector(`input.pplrcheckbox[data-frame="${frame}"]`);
    const ready = typeof window.pplrselecteritemoption === 'function';

    const already = boxes.some(b => b.checked || b.classList.contains('active'));
    if (already) return true;

    const first = boxes[0];
    if (ready) window.pplrselecteritemoption(first); else first.click();
    first.checked = true;
    first.classList.add('active');

    if (hidden) {
      hidden.value = getVal(first) || '';
      hidden.dispatchEvent(new Event('input',  { bubbles: true }));
      hidden.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }



  function trySet() {
    let done = true;
    for (const name of imageNames) if (!setFirstImage(name)) done = false;
    for (const frame of checkboxFrames) if (!setFirstCheckbox(frame)) done = false;
    if (!done && Date.now() < deadline) {
      setTimeout(trySet, 300);
    } else {
      verifyAndRetry(); // controllo finale
    }
  }
  
  (function () {
    // tutto il codice esistente sopra incluso imageNames, setFirstImage, setFirstCheckbox, ecc.
    trySet(); // ora chiamiamo la funzione dichiarata
  })();



  function verifyAndRetry() {
    let missing = false;
    for (const name of imageNames) {
      const elements = document.querySelectorAll(`.pplr-swatch-element[name="${name}"]`);
      const isSelected = Array.from(elements).some(el => el.classList.contains('selected'));
      if (!isSelected) {
        missing = true;
        break;
      }
    }
  
    for (const frame of checkboxFrames) {
      const boxes = document.querySelectorAll(`.pplr-checkbox-item[data-frame="${frame}"]`);
      const isChecked = Array.from(boxes).some(b => b.checked || b.classList.contains('active'));
      if (!isChecked) {
        missing = true;
        break;
      }
    }
  
    if (missing) {
      setTimeout(() => trySet(), 200); // ritenta dopo breve delay
    }
  }


  
})();